import {
  IndustrialBizSearchType,
  FactoronBizSearchType,
  InnoBizSearchType,
  MainBizSearchType,
  VentureBizSearchType,
  MiniClusterSearchType
} from '@generated/graphql';

export const searchTypeEnumToString = (
  value:
    | IndustrialBizSearchType
    | InnoBizSearchType
    | FactoronBizSearchType
    | MainBizSearchType
    | VentureBizSearchType
    | MiniClusterSearchType
) => {
  switch (value) {
    case IndustrialBizSearchType.BasicCompanyName:
      return '업체명';
    case IndustrialBizSearchType.BasicCity:
      return '지역';
    case IndustrialBizSearchType.BasicComplexName:
      return '단지';
    case IndustrialBizSearchType.BasicIndustryCategory:
      return '제조업';
    case IndustrialBizSearchType.BasicIndustrial:
      return '업종';
    case IndustrialBizSearchType.FullinvestigationCompanyScale:
      return '회사 규모';
    case IndustrialBizSearchType.Employees_2020FullTimeTotal:
      return '직원수';

    case FactoronBizSearchType.CompanyName:
      return '회사명';
    case FactoronBizSearchType.FactoryAddressRoadnam:
      return '도로명';
    case FactoronBizSearchType.IndustryName:
      return '업종명';
    case FactoronBizSearchType.FactorySize:
      return '공장크기';
    case FactoronBizSearchType.Product:
      return '생산품';
    case FactoronBizSearchType.JurisdictionOrganizationName:
      return '관할조직명';

    case InnoBizSearchType.CompanyName:
      return '업체명';
    case InnoBizSearchType.CompanyContact:
      return '연락처';
    case InnoBizSearchType.Address:
      return '주소';
    case InnoBizSearchType.EmployeesCount:
      return '종업원수';
    case InnoBizSearchType.IndustryCode:
      return '업종코드';
    case InnoBizSearchType.RelatedIndustry:
      return '업종';
    case InnoBizSearchType.RepresentativeName:
      return '대표자명';

    case MainBizSearchType.CompanyName:
      return '사업자명';
    case MainBizSearchType.IndustryCode:
      return '업종코드';
    case MainBizSearchType.RepresentativeName:
      return '대표자명';
    case MainBizSearchType.Region:
      return '지역';
    case MainBizSearchType.Location:
      return '소재지';
    case MainBizSearchType.IndustryName:
      return '업종명';

    case VentureBizSearchType.CompanyName:
      return '회사명';
    case VentureBizSearchType.Contact:
      return '전화번호';
    case VentureBizSearchType.IndustryName:
      return '업종';
    case VentureBizSearchType.Region:
      return '지역';
    case VentureBizSearchType.RelatedIndustry:
      return '관련업종';

    case MiniClusterSearchType.Region:
      return '지역';
    case MiniClusterSearchType.Base:
      return '거점';
    case MiniClusterSearchType.MiniClusterName:
      return '미니클러스터명';
    case MiniClusterSearchType.EnterPriseType:
      return '기업유형';
    case MiniClusterSearchType.CompanyName:
      return '기업명';
    case MiniClusterSearchType.IndustryUniversityInstituteCollaboration:
      return '산학연 구분';

    default:
      return '미분류';
  }
};
